"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Experiment = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _experimentActions = _interopRequireDefault(require("../v2/experimentActions"));

var _reactRedux = require("react-redux");

var _compose = _interopRequireDefault(require("recompose/compose"));

var _pure = _interopRequireDefault(require("recompose/pure"));

var _index = require("../../analytics/index");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Experiment = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Experiment, _React$Component);

  var _super = _createSuper(Experiment);

  function Experiment(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Experiment);
    _this = _super.call(this, props);
    var name = props.name,
        getTargetOffer = props.getTargetOffer,
        callToTarget = props.callToTarget;
    _this.onTargetRequestSuccess = _this.onTargetRequestSuccess.bind((0, _assertThisInitialized2.default)(_this));

    if (callToTarget && process.env.IS_BROWSER && (0, _get2.default)(window, 'adobe.target')) {
      var target = window.adobe.target;
      getTargetOffer(name);
      document.addEventListener(target.event.REQUEST_SUCCEEDED, _this.onTargetRequestSuccess);
    }

    return _this;
  }

  (0, _createClass2.default)(Experiment, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (process.env.IS_BROWSER && (0, _get2.default)(window, 'adobe.target')) {
        var target = window.adobe.target;
        document.removeEventListener(target.event.REQUEST_SUCCEEDED, this.onTargetRequestSuccess);
      }
    }
  }, {
    key: "onTargetRequestSuccess",
    value: function onTargetRequestSuccess(e) {
      var _this$props = this.props,
          name = _this$props.name,
          variationDetermined = _this$props.variationDetermined,
          callToTarget = _this$props.callToTarget,
          sendEnhancedTrackEvent = _this$props.sendEnhancedTrackEvent,
          analyticsProps = _this$props.analyticsProps,
          variations = _this$props.experimentConfig.variations;

      if (e.detail.mbox === name && callToTarget) {
        var hasVariation = e.detail.responseTokens;

        if (!Object.keys(variations).includes(name) && hasVariation) {
          var experimentName = (0, _get2.default)(e, "detail.responseTokens[0]['experience.name']", '');
          var experimentString = "".concat(name, ":").concat(experimentName);
          sendEnhancedTrackEvent({
            name: 'Experiment Entered',
            properties: _objectSpread({
              atTestOffer: experimentString,
              userId: '[[user.userInfo.response.userId]]',
              userType: '[[user.userType]]',
              userPrimaryZipCode: '[[user.primaryAddress.postalCode]]',
              userPrimaryAdZone: '[[user.primaryAddress.advertisingZone]]',
              userSelectedZipCode: '[[user.currentAddress.postalCode]]',
              userSelectedAdZone: '[[user.currentAddress.advertisingZone]]',
              href: typeof window !== 'undefined' ? window.location.href : null,
              pathName: '[[routing.locationBeforeTransitions.pathname]]'
            }, analyticsProps)
          });
          variationDetermined(e.detail);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          _this$props2$experime = _this$props2.experimentConfig,
          experiments = _this$props2$experime.experiments,
          variations = _this$props2$experime.variations,
          name = _this$props2.name;
      var variants = {};

      _react.default.Children.forEach(this.props.children, function (child) {
        if (! /*#__PURE__*/_react.default.isValidElement(child) || child.type.displayName !== 'ExperimentV3.Variant') {
          var error = new Error('Experiment children must be Variant Components');
          error.type = 'EXPERIMENT_INVALID_CHILD';
          throw error;
        } else {
          var isControlChild = child.props.control;
          var variantName = child.props.name;

          if (isControlChild) {
            if (variants.control) {
              var _error = new Error('An Experiment may only have one control variant');

              _error.type = 'EXPERIMENT_MULTIPLE_CONTROLS';
              throw _error;
            } else {
              variants.control = child;
            }
          }

          variants[variantName] = child;
        }
      });

      var variationName = (0, _get2.default)(variations, "".concat(name, ".variation.name"));
      var variant = (0, _get2.default)(variants, variationName) || (0, _get2.default)(variants, 'control');
      var experiment = (0, _get2.default)(experiments, name);

      if (variant) {
        return /*#__PURE__*/_react.default.cloneElement(variant, _objectSpread({}, experiment));
      }

      return null;
    }
  }]);
  return Experiment;
}(_react.default.Component);

exports.Experiment = Experiment;
Experiment.defaultProps = {
  callToTarget: true
};

var _default = (0, _compose.default)((0, _reactRedux.connect)(function (state) {
  return {
    experimentConfig: state.experimentV2
  };
}, _objectSpread(_objectSpread({}, _experimentActions.default), _index.analyticsActions)), _pure.default)(Experiment);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/experiment/v3/Experiment.js
// module id = 505
// module chunks = 25